import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { GeneralTable } from '../../../shared/Table/GeneralTable';
import { Box, styled, Typography } from '@mui/material';
import PrimaryBtn from '../../../shared/Buttons/PrimaryButton';
import { useNavigate } from 'react-router-dom';
import { MY_QUOTATION_HEAD_CELLS } from '../../../../utils/constans/tableHeads/quotationTableHeadCells';
import useMyQuotations from '../../../../hooks/quotations/useMyQuotations';
import {
    MyQuotationData,
    MyQuotationsHeadCellContent,
} from '../../../../models/Quotations';
import { MyQuotationsTableRow } from '../../../quotations/MyQuotationsTableRow';

const TitleWrapper = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '20px',
}));

export const MyQuotations = () => {
    const { t } = useTranslation('quotations', {
        keyPrefix: 'MY_QUOTATIONS',
    });
    const navigate = useNavigate();
    //TODO: bekötni a rest-et swr-el
    const quotations = useMyQuotations();
    const fullList = quotations.getQuotations();
    const isLoading = false;

    const tableHeadSettings = {
        translateNs: 'quotations',
        translatePrefix: 'QUOTATIONS.TABLE_HEAD',
        selectable: true,
        headContent: MY_QUOTATION_HEAD_CELLS,
    };

    const tableToolbarSettings = {
        translateNs: 'quotations',
        translatePrefix: 'QUOTATIONS.TABLE_TOOLBAR',
    };
    const addNew = () => {
        navigate('/quotation/0');
    };

    const filterTerm = (search) => {
        return fullList.filter((elem) => {
            return (
                elem.quoteID.includes(search) ||
                elem.status.toLowerCase().includes(search.toLowerCase())
            );
        });
    };

    const forceRefresh = () => {};

    return (
        <>
            <TitleWrapper>
                <PageTitle>{t('TITLE')}</PageTitle>
                {/*<PrimaryBtn onClick={addNew}>{t('ADD_NEW')}</PrimaryBtn>*/}
            </TitleWrapper>
            <Box>
                <Typography paragraph>{t('DESCRIPTION')}</Typography>
            </Box>
            <GeneralTable<MyQuotationData, MyQuotationsHeadCellContent>
                fullList={fullList}
                rowComponent={MyQuotationsTableRow}
                filterTerm={filterTerm}
                defaultOrderBy={'orderDate'}
                selectHandleId={'quoteID'}
                tableHeadSettings={tableHeadSettings}
                tableToolbarSettings={tableToolbarSettings}
                forceRefresh={forceRefresh}
                isLoading={isLoading}
            />
        </>
    );
};
